var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAtfL = function SvgAtfL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 326 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.556 499H0V0h64.969v444.11h260.587V499Z",
    fill: "currentColor"
  })));
};
export { SvgAtfL as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzI2IDQ5OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyNS41NTYgNDk5SDBWMEg2NC45Njg1VjQ0NC4xMUgzMjUuNTU2VjQ5OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";